import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgVitaminCGlyphSecondary from './svgs/VitaminCGlyphSecondary.js';
import SvgVitaminCGlyph from './svgs/VitaminCGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var vitaminCGlyph = (props => useIcon(SvgVitaminCGlyph, SvgVitaminCGlyphSecondary, props));

export { vitaminCGlyph as default };
